import { useState, useEffect, useRef } from 'react'

export function useContainerWidth() {
  const ref = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    if (!ref.current) return
    
    if (typeof window === 'undefined' || !('ResizeObserver' in window)) {
      setWidth(1024)
      return
    }

    const observer = new window.ResizeObserver((entries) => {
      for (const entry of entries) {
        setWidth(entry.contentRect.width)
      }
    })
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])

  return [ref, width] as const
}
